import React from "react";

export default function Loader() {
  return (
    <>
      <div className="loader-sec">
        <div className="loader" style={{ margin: "0 auto" }}></div>
      </div>
    </>
  );
}
